import axios from "../axios";

export const articleInfo = (params) => {
    return axios('get', '/api/article/getArticleDetail/' + params);
}

// 获取轮播图详情
export const slideshowInfo = (params) => {
    return axios('get', '/api/slideshow/getDetailBySlideshowId/' + params);
}